import React from 'react'
import {
  PieChartJS,
  IChartJSProps
} from '../../../components/common/charts/ChartJS'
import AnalyticsPieChartLegend, {
  IAnalyticsPieChartLegend
} from './AnalyticsPieChartLegend'
import './AnalyticsPieChart.less'

interface IAnalyticsPieChartProps extends IChartJSProps {
  config: Chart.ChartConfiguration
  showLegend: boolean
  legendData: IAnalyticsPieChartLegend[]
  className: string
}

function buildPieChartJSData(legendData) {
  const graphData = {
    data: [],
    backgroundColor: [],
    borderWidth: 0
  }

  graphData.data = legendData.map((item) => item.value)
  graphData.backgroundColor = legendData.map((item) => item.color)

  return {
    labels: legendData.map((item) => item.label),
    datasets: [graphData]
  }
}

const AnalyticsPieChart = ({
  config,
  showLegend,
  legendData,
  className,
  ...props
}: IAnalyticsPieChartProps) => {
  config.data = buildPieChartJSData(legendData)

  return (
    <div className="AnalyticsPieChart">
      <div className={className}>
        <PieChartJS {...props} config={config} />
      </div>

      {showLegend && <AnalyticsPieChartLegend legendData={legendData} />}
    </div>
  )
}

export default AnalyticsPieChart
